import React, { useContext } from "react";
import { PaymentInfo } from "../lib/types";
import usePaymentInfo from "../hooks/usePaymentInfo";
import PaymentInfoContext from "../context/PaymentInfoContext";

const PaymentInfoProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  useContext<PaymentInfo>(PaymentInfoContext);
  const paymentInfo = usePaymentInfo();

  return (
    <PaymentInfoContext.Provider value={paymentInfo}>
      {children}
    </PaymentInfoContext.Provider>
  );
};

export default PaymentInfoProvider;
